(function ($) {
  Drupal.behaviors.oculus_mod3_video = {
    attach: function (context) {
      $('#oculus_mod3', context).once('oculus_mod3_video', function () {
        $(window).on('load', function () {
          var urlHash = window.location.href.split('#')[1];

          if (urlHash === 'oculus_mod3') {
            $('html,body').animate(
              {
                scrollTop: $('#' + urlHash).offset().top - 85
              },
              1500
            );
          }
        });
        if (!$('#oculus_mod3_video').data('yt1-src')) {
          $('#oculus_mod3 .oculus_mod3_video_play, #oculus_mod3 .oculus_mod3_video_cta').hide();
        }
      });
    }
  };
})(jQuery);
